import React from 'react';
import { Upload, FileText, X } from 'lucide-react';
import { Label } from './sharedVendorUI';

/**
 * PDF picker for the vendor "Upload Document" requirement. Does not upload —
 * the parent uploads after a successful save (the S3 object name comes from the
 * save SP's DownloadExt output, so the actual upload can only happen post-save).
 */
const DocumentUploadField = ({ file, onFileChange, disabled, required = true }) => {
    const handlePick = (e) => {
        const f = e.target.files?.[0] || null;
        if (f && !f.name.toLowerCase().endsWith('.pdf')) {
            e.target.value = '';
            onFileChange(null);
            return;
        }
        onFileChange(f);
    };

    return (
        <div>
            <Label required={required}>Upload Document (PDF)</Label>
            {!file ? (
                <label className={`flex items-center justify-center gap-2 w-full px-4 py-3 rounded-xl border-2 border-dashed text-sm font-medium cursor-pointer transition-colors ${
                    disabled
                        ? 'border-gray-200 dark:border-gray-700 text-gray-400 cursor-not-allowed'
                        : 'border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-400 hover:border-indigo-400 hover:text-indigo-500'
                }`}>
                    <Upload className="h-4 w-4" /> Choose PDF file
                    <input type="file" accept=".pdf,application/pdf" className="hidden" onChange={handlePick} disabled={disabled} />
                </label>
            ) : (
                <div className="flex items-center justify-between px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/30">
                    <div className="flex items-center gap-2 min-w-0">
                        <FileText className="h-4 w-4 text-indigo-500 flex-shrink-0" />
                        <span className="text-sm text-gray-700 dark:text-gray-300 truncate">{file.name}</span>
                        <span className="text-xs text-gray-400 flex-shrink-0">({(file.size / 1024).toFixed(1)} KB)</span>
                    </div>
                    <button
                        type="button"
                        onClick={() => onFileChange(null)}
                        disabled={disabled}
                        className="p-1 rounded-lg text-rose-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/20 disabled:opacity-40"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default DocumentUploadField;
